import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CertificatesPrivateService, FeedMessageService, showSuccess, UtilsService } from '@services/index.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfirmCancelComponent } from '@shared/index.shared';
import { CertificateResetPinRequest, ErrorCode } from '@models/index.model';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-private-cert-regenerate-pin',
    templateUrl: './dialog-private-cert-regenerate-pin.component.html',
    styles: [],
    standalone: false
})
export class DialogPrivateCertRegeneratePinComponent implements OnInit {
  public isMobile: boolean;
  tooltipTitle: any;
  sendingInfo: boolean = false;

  dataActivationCode: string = '';
  dataNewPin: string = '';
  dataRepeatNewPin: string = '';

  hidePinNew: boolean = true;
  hidePinRepeat: boolean = true;

  _resetPinCertificate: any;
  certificateResetPinRequest: CertificateResetPinRequest;

  constructor(
    public dialogRef: MatDialogRef<DialogPrivateCertRegeneratePinComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    public translate: TranslateService,
    private _notify: FeedMessageService,
    public _utils: UtilsService,
    private _privCertsServ: CertificatesPrivateService
  ) {
    this.isMobile = environment.platform === 'mobile';
    translate.get(['GLOBAL.TOOLTIP']).subscribe(res => {
      this.tooltipTitle = res['GLOBAL.TOOLTIP'];
    });
  }

  ngOnInit() {
  }

  sendPinReset() {
    if (this.dataNewPin === this.dataRepeatNewPin) {
      this.resetPinCertificate();
    }
  }

  resetPinCertificate() {
    this.sendingInfo = true;
    this.certificateResetPinRequest = {
      personalCertificateId: this.data.id,
      code: this.dataActivationCode,
      newPin: this.dataNewPin
    };
    this._privCertsServ.resetPinPersonalCertificate(this.certificateResetPinRequest).subscribe(res => {
      this._resetPinCertificate = res;
      if (this._resetPinCertificate.errorCode === ErrorCode.OK ) {
        this._notify.feedBackResult(this._resetPinCertificate.messageType, this._resetPinCertificate.message, showSuccess);
        this.sendingInfo = false;
        this.dialogRef.close(true);
      }
      this.cleanPin();
    },
    () => {
      this.sendingInfo = false;
      this.cleanPin();
    });
  }

  cleanPin() {
    // this.dataActivationCode = '';
    this.dataNewPin = '';
    this.dataRepeatNewPin = '';
  }

  cancelChanges() {
    const dialogRef = this.dialog.open(DialogConfirmCancelComponent, {
      width: '400px',
      data: {}
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.dialogRef.close(false);
      }
    });
  }
}

